/* eslint-disable max-len */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/alt-text */
import React, { useRef, useEffect, useState } from 'react';
import { SLTXFormatRootFileVariant } from '../../fileFormats/sltx/sltx';
import { TreeOptionSelections, buildTreeOptionSelections } from '../../modelConfiguration/data/optionsSelection';
import { ModelConfigurationTooltip } from '../modelConfiguration/modelConfigurationTooltip';

interface ModelVariantParameters {
  // Available variants of the model
  variant: SLTXFormatRootFileVariant;
  // Current set of options selected by the user
  optionsSelectionState : TreeOptionSelections,
  // Function to update the options selection state
  updateOptionsSelectionState : (selection : TreeOptionSelections) => void,
  // Function to adjust the path to the resources like images
  getResourcePath : (path : string) => string,
}

export function ModelVariant({
  variant,
  optionsSelectionState,
  updateOptionsSelectionState,
  getResourcePath,
} : ModelVariantParameters) : JSX.Element {

  const [isVariantSelected, setIsVariantSelected] = useState<boolean>(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ left: 0, top: 0 });
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {

    let isVariantSelectedByUser = true;

    // Go through the variant composition and check if the current options selection state matches
    for (let i = 0; i < variant.variantComposition.length; i++) {

      const compositionObject = variant.variantComposition[i];

      const optionForGroup = optionsSelectionState.find((selection) => {
        return (
          (selection.groupID === compositionObject.groupId)
        && (selection.optionID === compositionObject.optionId)
        );
      });

      if (optionForGroup === undefined) {
        isVariantSelectedByUser = false;
        break;
      }
    }

    setIsVariantSelected(isVariantSelectedByUser);
  }, [optionsSelectionState, variant]);

  const handleSelectVariant = () => {

    updateOptionsSelectionState(
      buildTreeOptionSelections(
        variant.variantComposition,
      ),
    );
  };

  const getVariantClassName = () => {

    if (isVariantSelected) {
      return 'variant-selected';
    }
    return 'variant-unselected';
  };

  const handleMouseEnter = (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => {

    if (containerRef.current) {
      const rect = event.currentTarget.getBoundingClientRect();
      const containerRect = containerRef.current.getBoundingClientRect();

      // const tooltipWidth = 300;
      const left = containerRect.x;
      const top = rect.bottom + 10;

      setTooltipPosition({ left, top });
    }
    setShowTooltip(true);

  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  return (
    <div
      ref={containerRef}
      className={getVariantClassName()}
      onClick={handleSelectVariant}
    >
      <div className="variant-content">
        <div className="variant-image-parent">
          <img className="variant-image" src={getResourcePath(variant.imageRef)} alt="option preview" title={variant.name} />

          {showTooltip && (
            <ModelConfigurationTooltip
              imageUrl={getResourcePath(variant.imageRef)}
              tagString={variant.name}
              tooltipPosition={tooltipPosition}
            />
          )}
        </div>
        <div
          className="variant-tag-string"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          {variant.name}
        </div>
      </div>
    </div>
  );
}
